module.exports = __webpack_public_path__ + "img/0e84664.png";